import axios from 'axios';

import { registerInterceptors } from './interceptors';

// O authenticator usa URI versioning (defaultVersion '1' em main.ts) — toda
// rota vive sob /v1/, por isso o sufixo abaixo. Caminho RELATIVO de
// propósito — resolve na origem do portal em qualquer ambiente
// (localhost:7004 no yarn dev, dev/hml/prod.pe.gov.br no deploy). Com URL
// absoluta o build embutiria o host errado.
const baseURL =
  process.env.REACT_APP_AUTHENTICATOR_SERVICE ||
  '/api/empreende-mulher-api-authenticator/v1';

export const authenticatorApi = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

registerInterceptors(authenticatorApi);
